import ReactGA from 'react-ga4';

// ============================================================
// PUT YOUR CANDIDATE PORTAL GA4 MEASUREMENT ID HERE
// Get it from: analytics.google.com > Admin > Data Streams
// ============================================================
const MEASUREMENT_ID = 'G-ETJEPN18YY';

/**
 * Initialize Google Analytics 4
 * Call this once when the app loads
 */
export const initGA = () => {
  if (!MEASUREMENT_ID || MEASUREMENT_ID === 'G-XXXXXXXXXX') {
    console.warn('GA4: Please set your Measurement ID in src/utils/analytics.js');
    return;
  }
  
  ReactGA.initialize(MEASUREMENT_ID);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('GA4: Initialized with ID', MEASUREMENT_ID);
  }
};

/**
 * Track a page view
 * @param {string} path - The page path (e.g., '/profile')
 * @param {string} [title] - Optional page title
 */
export const trackPageView = (path, title) => {
  if (!MEASUREMENT_ID) return;
  
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title || document.title,
  });
  
  if (process.env.NODE_ENV === 'development') {
    console.log('GA4: Page view tracked -', path);
  }
};

/**
 * Track a custom event (for future use)
 * @param {string} category - Event category
 * @param {string} action - Event action
 * @param {string} [label] - Optional event label
 * @param {number} [value] - Optional numeric value
 */
export const trackEvent = (category, action, label, value) => {
  if (!MEASUREMENT_ID) return;
  
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
  
  if (process.env.NODE_ENV === 'development') {
    console.log('GA4: Event tracked -', { category, action, label, value });
  }
};

